import React from 'react';
import { LucideIcon, icons } from 'lucide-react';

interface DynamicIconProps {
  name: string;
  className?: string;
  size?: number;
}

export function DynamicIcon({ name, className, size }: DynamicIconProps) {
  const Icon = icons[name as keyof typeof icons] as LucideIcon;
  
  if (!Icon) {
    return <div className={className} style={{ width: size, height: size }} />;
  }
  
  return <Icon className={className} size={size} />;
}